import {useParams} from "react-router-dom";
import {Components} from "traitify-widgets";
import useTraitifyWidgets from "lib/hooks/use-traitify-widgets";

export default function Results() {
  const {id: assessmentID} = useParams();
  const widgetProps = useTraitifyWidgets();
  if(!widgetProps) { return; }

  widgetProps.assessmentID = assessmentID;

  return (
    <div className="container">
      <Components.Container {...widgetProps}>
        <Components.Results.Container />
      </Components.Container>
    </div>
  );
}
